import { render, staticRenderFns } from "./DraggableEvent.vue?vue&type=template&id=52635ee8&scoped=true&"
import script from "./DraggableEvent.vue?vue&type=script&lang=js&"
export * from "./DraggableEvent.vue?vue&type=script&lang=js&"
import style0 from "./DraggableEvent.vue?vue&type=style&index=0&id=52635ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52635ee8",
  null
  
)

export default component.exports